










































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import UserDetail from "@/views/users/detail.vue";

@Component({
  components: {
    UserDetail
  }
})
export default class extends Mixins(MyList) {
  @Prop({ default: 0 }) clubId!: number;

  dispatchType = "club/members";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "用户名", dataIndex: "username" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "馆长", scopedSlots: { customRender: "is_manager" } },
    { title: "加入时间", dataIndex: "created_time" },
    { title: "禁言", scopedSlots: { customRender: "is_forbid_talk" } },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ club_id: this.clubId }, false);
  }
}
